<template>
	<div>
		<el-page-header @back="goBack" content="测评结果设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="topic-outer">
			<div class="appraisal-center fonts marr">
				<div>
					<span>角色：</span>
					<span>
						<el-tag
							class="tag-marr"
							:key="index"
							:class="{ activeBg: selectedLevel1Id == item.examDimensionId }"
							effect="plain"
							@click="activeEvent(item)"
							v-for="(item, index) in level1List"
							>{{ item.name }}</el-tag
						>
					</span>
				</div>
				<div class="marr">
					<el-button @click="handleClick('add')" type="success" size="small"
						>添加结果 <i class="el-icon-plus"></i></el-button>
				</div>
				<div class="marr">
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="resulData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="60"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="minScore"
								label="最小值"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ dataHandling(scope.row.minScore) }}
									</div>
								</template>
							</el-table-column>

							<el-table-column
								prop="maxScore"
								label="最大值"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ dataHandling(scope.row.maxScore) }}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								prop="keyword"
								label="标签"
								width="80"
								align="center"
							>
							</el-table-column>
              <el-table-column
                  prop="seq"
                  label="排序"
                  width="80"
                  align="center"
              >
              </el-table-column>
							<el-table-column
								v-for="item in getColumn"
								:key="item.name"
								:label="item.label"
								:prop="item.name"
								width="140"
								align="center"
							>
								<template slot-scope="scope">
									<div
										v-html="scope.row[item.name]"
										v-if="item.attrs.html"
									></div>
									<div v-else>{{ scope.row[item.name] }}</div>
								</template>
							</el-table-column>

							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="100"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleClick('edit', scope.row)"
										type="primary"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!--结果设置-->
		<el-dialog
			title="结果设置"
			:visible.sync="dialogVisible"
			width="1080px"
			top="30px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('question')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-row type="flex">
						<el-col :span="8">
							<el-form-item label="角色">
								<div>{{ selectedLevel1Info.name }}</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex">
            <el-col :span="8">
              <el-form-item label="答案分值" prop="answer">
                <el-input
                    placeholder="请输入答案分值"
                    v-model="params.answer"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
						<el-col :span="8">
							<el-form-item label="最小值" prop="minScore">
								<el-input
									placeholder="请输入最小值"
									v-model="params.minScore"
									type="number"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="最大值" prop="maxScore">
								<el-input
									placeholder="请输入最大值"
									v-model="params.maxScore"
									type="number"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="名称" prop="name">
								<el-input
									placeholder="请输入名称"
									v-model="params.name"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="标签" prop="keyword">
                <el-input
                    placeholder="请输入标签"
                    v-model="params.keyword"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="排序" prop="seq">
                <el-input
                    placeholder="请输入排序"
                    v-model="params.seq"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
					
					<el-form-item
						v-for="item in getFormConfig"
						:key="item.name"
						:label="item.label"
						:prop="item.name"
					>
						<component
							v-if="item.show ? innerVisible : true"
							:is="item.el"
							v-model="params[item.name]"
							v-bind="item.attrs"
							:params="params ? params : ''"
						/>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>

	</div>
</template>

<script>
import { emptyShow, isEmpty } from "@utils/tools";
import richText from "@comp/richText";
import { getEditFormConfig, getColumnConfig } from "./xlsySet.js";

export default {
	name: "mjywlList",
	components: {
		richText,
		"rich-text": richText,
	},
	data() {
		return {
			scoreDecimal: 0,
			columnConfig: getColumnConfig(),
			formModelConfig: getEditFormConfig(),
			dimensionInfoList: [],
			emptyShow,
			isEmpty,
			detalisObj: {},
			// 维度数据
			level1List: [], // nodeLevel = 1, parentId = 0
			// 选中的维度ID
			selectedLevel1Id: 0,
			// 选中的维度对象
			selectedLevel1Info: {},
			// 当前操作的维度信息（用于编辑等操作）
			currentDimensionInfo: {},
			params: {},
			srcList: [],
			isMoer: true,
			loading: false,
			resulData: [],
			innerVisible: false,
			dialogVisible: false,
			rules: {
				minScore: [
					{
						required: true,
						message: "请输入最小值",
						trigger: "blur",
					},
				],
				maxScore: [
					{
						required: true,
						message: "请输入最大值",
						trigger: "blur",
					},
				],
			},
			languageList: [],
			languageCode: "",
			examResultId: "",
			keywordList:[
				{id:'V',name:'V'},
				{id:'A',name:'A'},
				{id:'P',name:'P'}
			]
		};
	},
	computed: {
		/**
		 * 根据小数点位数获取整数倍数
		 */
		intMultiple() {
			return 1;
		},
		getColumn() {
			const code = this.currentDimensionInfo && this.currentDimensionInfo.code;
			console.log(code,this.columnConfig[code])
			return code && this.columnConfig[code] ? this.columnConfig[code] : this.columnConfig.DEFAULT;
		},
		getFormConfig() {
			const code = this.currentDimensionInfo && this.currentDimensionInfo.code;
			return code && this.formModelConfig[code] ? this.formModelConfig[code] : this.formModelConfig.DEFAULT;
		}
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs.ruleForm.resetFields();
				this.params = {};
				this.innerVisible = false;
			}
		},
	},
	mounted() {
		this.getAppraisalData();
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question" && this.examResultId) {
				this.getDetail();
			}
		},
		async getDetail() {
			this.innerVisible = false;
			const { data: resData } = await this.$get(
				`exam/result/info/${this.examResultId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) return;
			resData.data.minScore = resData.data.minScore / this.intMultiple;
			resData.data.maxScore = resData.data.maxScore / this.intMultiple;
			this.params = resData.data;
			this.innerVisible = true;
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
			this.getDimensionList();
		},

		
		/**
		 * 获取测评维度列表
		 */
		async getDimensionList() {
			this.level1List = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/dimension/list`, {
				params: {
					examId: this.$route.query.examId,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.dimensionInfoList = resData.data;
				// 获取一级维度（nodeLevel = 1, parentId = 0）
				this.level1List = resData.data.filter((item) => item.parentId == 0 && item.nodeLevel == 1);
				
				if (this.level1List.length > 0) {
					this.selectedLevel1Id = this.level1List[0].examDimensionId;
					this.selectedLevel1Info = this.level1List[0];
					this.currentDimensionInfo = this.level1List[0];
					this.getWdResultList();
				}
			}
		},
		/**
		 * 维度切换
		 */
		activeEvent(item) {
			this.selectedLevel1Id = item.examDimensionId;
			this.selectedLevel1Info = item;
			this.currentDimensionInfo = item;
			this.getWdResultList();
		},
		/**
		 * 结果编辑
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			this.params = {};
			this.dialogVisible = true;
			this.innerVisible = false;
			if (type == "add") {
				this.params = {};
				this.innerVisible = true;
			}
			if (type == "edit") {
				this.examResultId = row.examResultId;
				const { data: resData } = await this.$get(
					`exam/result/info/${row.examResultId}`,
					{
						headers: {
							isLoading: true,
							"Language-Code": this.languageCode,
						},
					}
				);
				if (resData.result != 200) return;
				resData.data.minScore = resData.data.minScore / this.intMultiple;
				resData.data.maxScore = resData.data.maxScore /  this.intMultiple;
				this.params = resData.data;
				this.innerVisible = true;
			}
		},


		/**
		 * 处理数据为小数
		 */
		dataHandling(data) {
			return data / this.intMultiple;
		},
		/**
		 * 删除结果
		 */
		handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/result/info/${row.examResultId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.$message.success("删除成功!");
				this.getWdResultList();
			});
		},
		/**
		 * 获取测评维度结果列表
		 */
		async getWdResultList() {
			this.loading = true;
			
			// 确定当前使用的维度信息
			let currentDimension = {};
			
			if (this.selectedLevel1Id && this.selectedLevel1Info.code) {
				currentDimension = this.selectedLevel1Info;
			}
			
			// 更新当前维度信息
			this.currentDimensionInfo = currentDimension;
			
			if (!currentDimension.code) {
				this.loading = false;
				this.resulData = [];
				return;
			}
			
			let temp = {
				examId: this.$route.query.examId,
				examDimensionCode: currentDimension.code
			};
			
			const { data: resData } = await this.$get(`exam/result/list`, {
				params: temp,
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.resulData = resData.data;
			} else {
				this.resulData = [];
			}
		},
		/**
		 * 保存设置结果
		 */
		handleEdit() {
			if (this.params.minScore*this.intMultiple>this.params.maxScore*this.intMultiple) {
				this.$message.error("最小值不能大于最大值");
				return;
			}
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const _params = {
							...this.params,
							minScore: this.params.minScore * this.intMultiple,
							maxScore: this.params.maxScore * this.intMultiple,
						}
					if (this.clickType == "add") {
						_params.examDimensionCode = this.currentDimensionInfo.code;
            _params.scoreDecimal = this.scoreDecimal;
						_params.examId = this.$route.query.examId;
						const { data: resData } = await this.$post(
							"exam/result/info",
							_params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.getWdResultList();
						this.examResultId = resData.data;
						this.dialogVisible = false;
						this.$message.success("添加成功!");
						this.params = {};
					} else {
						_params.minScore = this.params.minScore * this.intMultiple;
						_params.maxScore = this.params.maxScore * this.intMultiple;
						const { data: resData } = await this.$put(
							"exam/result/info",
							_params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.getWdResultList();
						// this.dialogVisible = false;
						this.$message.success("修改成功!");
					}
				});
			});
		},
		goBack() {
			this.$router.back();
		},
		//过滤标签数据
		setHtmlData(str) {
			let obj = "";
			if (str) {
				obj = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
			}
			return obj;
		},

	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}



.public-dialog-form {
	height: 72vh;
	overflow-y: scroll;
}
</style>
